import { bazaar_api_v3_sellers_liked_url } from 'mk/urls/functions';
import {
    sellerSearchLoadApi,
    SellerSearchLoadAction,
    SellerSearchLoadNormalizedResponse,
    SELLER_SEARCH_LOAD,
} from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('bazaar/SellerSearch.sagas');

interface LoadApiResponse {
    body: {
        total: number;
        entities: SellerSearchLoadNormalizedResponse['entities'];
        result: SellerSearchLoadNormalizedResponse['result'];
    };
}

function* load({ xhr, start }: SellerSearchLoadAction & XHRAction) {
    yield put(sellerSearchLoadApi.request(start));

    try {
        const response: LoadApiResponse = yield call(() => xhr.get(bazaar_api_v3_sellers_liked_url({ start })));

        yield put(
            sellerSearchLoadApi.success(start, response.body.total, {
                entities: response.body.entities,
                result: response.body.result,
            }),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(sellerSearchLoadApi.failure(start, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(SELLER_SEARCH_LOAD, load)]);
}
